const ORIGIN_APPLICATION = {
    GATEWAY: { name: 'GATEWAY', title: 'GATEWAY' },
    PAYLUDD: { name: 'PAYLUDD', title: 'PAYLUDD' },
    BROADCAST: { name: 'BROADCAST', title: 'PACE' }
};

export default ORIGIN_APPLICATION;